const data = {
    title: 'Setup Security Questions',
    info: ["Please choose your security questions and answers that can be used to verify your identity."],
    pages: ['One Time Passcode Authentication', 'Confirm One Time Passcode', 'Setup Security Questions', 'Personal Details', 'Manage Address'],
    stepperStyle: { width: '100%', height: 60, paddingRight: 90, paddingLeft: 150 },
    stepperDivStyle: {width: '100%'}
  }

  export default data;